 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class=" is-centered">


      <div id="card" class="card-container" v-if="customBlends.length">
        <!-- <h1 class="title">Order Request</h1> -->
        <!-- <hr> -->
        <b-collapse v-model="isCustomBlendOpen" animation="slide" @open="openOrClose()" @close="openOrClose()">

          <template #trigger>
            <h2 class="title is-5">
              <span>
                <b-icon v-if="isCustomBlendOpen" size="is-small" icon="chevron-down"/>
                <b-icon v-else size="is-small" icon="chevron-right"/>
              </span>
              &nbsp;Your Custom Blends
            </h2>
          </template>

            <br>
            <p v-if="!this.customBlends.length">There's nothing here!</p>
            <b-table :data="customBlends" v-if="this.customBlends.length">
            <template slot-scope="blend">
          
              <b-table-column field="idk" label="Product Name">
                {{ blend.row.productName}}
              </b-table-column>

              <b-table-column field="grind" label="Grind">
                {{ blend.row.grind }}
              </b-table-column>

              <b-table-column field="customblendweight" label="Weight">
                {{ blend.row.weight }} lbs
              </b-table-column>

              <b-table-column field="price" label="Price" numeric>
                {{ blend.row.priceWholesale | currency }}
              </b-table-column>

              <b-table-column field="RepeatButton" label=" " numeric>
                  <button v-on:click="checkQuantityBlend(blend.row)" class="button is-primary is-pulled-right">+</button>
              </b-table-column>
            </template>
          </b-table>
          <br>
        </b-collapse>
      </div>

      <div id="card" class="card-container">
        <b-collapse v-model="isRecentlyPurchasedOpen" animation="slide" @open="openOrCloseRP()" @close="openOrCloseRP()">

          <template #trigger>
            <h2 class="title is-5">
              <span>
                <b-icon v-if="isRecentlyPurchasedOpen" size="is-small" icon="chevron-down"/>
                <b-icon v-else size="is-small" icon="chevron-right"/>
              </span>
              &nbsp;Frequently Purchased
            </h2>
          </template>
            <br>
            <p v-if="!this.recentPurchases.length">There's nothing here!</p>
            <b-table :data="recentPurchases">
            <template slot-scope="recent">
          
              <b-table-column field="recentProduct" label="Product Name">
                {{ recent.row.productName}}
              </b-table-column>

              <b-table-column field="recentDescription" label="Description">
                {{ recent.row.description }}
              </b-table-column>

              <b-table-column field="recentPrice" label="Price" numeric>
                {{ recent.row.price | currency }}
              </b-table-column>

              <b-table-column field="RepeatButton" label=" " numeric>
                  <button v-on:click="checkQuantityRecent(recent.row)" class="button is-primary is-pulled-right">+</button>
              </b-table-column>
            </template>
          </b-table>
          <br>
        </b-collapse>
      </div>

      <div id="card" class=" card-container">
        <h2 class="title is-5">Products</h2>

        <b-tabs size="is-large" class="block" @input="setTab">
            <b-tab-item label="Coffee"></b-tab-item>
            <b-tab-item label="Sweet Justice"></b-tab-item>
            <b-tab-item label="Limited Edition"></b-tab-item>
            <b-tab-item label="Supplies"></b-tab-item>
            <b-tab-item label="Green Beans"></b-tab-item>
            <b-tab-item label="All Products"></b-tab-item>
        </b-tabs>

        <b-field>
              <b-input type="text" placeholder="Search products..." v-model="productFilter"></b-input>
        </b-field> 
        <div class="productWindow row is-centered">
          <h1 class="noProducts" v-if="!this.products.length"><strong>No products found!</strong></h1>  
          <b-table
            v-if="this.products.length"
            :data="products"
            ref="table"
            backend-pagination
            paginated
            hoverable
            :pagination-simple="false"
            :show-detail-icon="false"
            :per-page="perPage"
            :total="total"
            detailed
            @details-open="(row, index) => loadLineData(row.base_sku)"
            @page-change="onPageChange">
            <template slot-scope="props">
              <b-table-column field="productName" label="Product Name" width="500">
                {{ props.row.productName}}
              </b-table-column>

              <b-table-column field="description" label="Description">
                  <!-- <div v-html="props.row.description"></div> -->
                  {{props.row.wholesaleNotes}}
              </b-table-column>

              <b-table-column field="showDetails"  numeric>
                    <b-button :icon-right="props.row.isOpen ? 'chevron-up' : 'chevron-down'" @click="props.row.isOpen=!props.row.isOpen, toggle(props.row)" type="email" placeholder="email" class="button is-primary is-pulled-right">Buying Options</b-button>
              </b-table-column>

            </template>
            <template slot="detail" slot-scope="props" class="subtableBackground">
                <article class="media">
                    <figure class="media-left">
                    </figure>
                    <div class="media-content">
                        <div class="content subTableThings">
                            <b-table :data="props.row.productLines">
                              <template slot-scope="test">
                            
                                <b-table-column field="productName" label="Product Name">
                                  {{ test.row.productName}}
                                </b-table-column>                                
                                
                                <b-table-column field="weight" label="Weight">
                                  {{ test.row.weight}} lbs
                                </b-table-column>

                                <b-table-column field="grind" label="Grind">
                                  {{ test.row.grind}}
                                </b-table-column>

                                <b-table-column field="price" label="Price" numeric>
                                  {{ test.row.priceWholesale ? test.row.priceWholesale : 0 | currency}}
                                </b-table-column>

                                <b-table-column field="RepeatButton" label=" " numeric>
                                    <!-- <button v-on:click="addToCart(test.row)" class="button is-primary is-pulled-right">+</button> -->
                                   <button v-on:click="checkQuantity(test.row)" class="button is-primary is-pulled-right">+</button>
                                </b-table-column>
                              </template>
                            </b-table>
                        </div>
                    </div>
                </article>
            </template>
          </b-table>
        </div>
      </div>
    </div>     
  </div>
</template>

<script>
import loginAPI from "@/api/LoginAPI.js";
import sharedAPI from "@/api/SharedAPI.js";
import store from "../store.js";
import { mapMutations, mapState } from "vuex";
import axios from "axios";

export default {
  name: "OrderRequest",
  props: ["usernameProp"],
  data() {
    return {
      productFilter: "",
      username: null,
      password: null,
      hash: null,
      errorMsg: null,
      isLoading: true,
      isFullPage: true,
      notificationDuration: 4000,
      total: 0,
      perPage: 15,
      page: 1,
      products: [],
      customBlends: [],
      productLines: [],
      recentPurchases: [],
      tabFilter: "Coffee",
      isCustomBlendOpen: true,
      isRecentlyPurchasedOpen: true,
    };
  },

  filters: {
    currency: function(price){
      return "$".concat(price.toFixed(2));
    }
  },

  created() {
    this.loadRecentPurchases();
    this.loadCustomBlends();
    this.loadData();
  },

  computed: {
    ...mapState(["userInfo", "cart"]),

    offset: function() {
      return this.page * this.perPage - (this.perPage - 1);
    }
  },

  watch: {
    'productFilter': function(val, oldVal){
      this.page = 1
      this.productLookup(this)
    }
  },

  methods: {
    ...mapMutations([
      "setCampaigns",
      "setEmails",
      "setCampaignsAndEmails",
      "setSelectedCampaign",
      "setCart"
    ]),
    toggle(row) {
            this.$refs.table.toggleDetails(row)
    },

    loadRecentPurchases(){
      var self = this;
      axios.post(`proxy.php?/layouts/recent-order-lookup/_find`, {
        query: [
          {
            _kftWholesalerID: "=" + self.userInfo.userID,
            showOnWeb: "1",
            zcnCanBeReordered: "1"

          }
        ],
        sort: [
          {
            fieldName: "timesOrdered", sortOrder: "descend"
          }
        ],
        limit: 3,
      })
      .then(response => {
        self.recentPurchases = [];
        var parse = response.data.response.data;

        parse.forEach(function(element) {
          self.recentPurchases.push(element.fieldData);
        });
        
        })
        .catch(error=>{
          console.log(error)
        })
    },

    loadCustomBlends(){
      var self = this
      axios.post(`proxy.php?/layouts/product-lookup/_find`, {
        query: [
            {
              _kftWholesalerID: "=" + self.userInfo.userID,
              isCustomBlend: "=" + 1,
              isCustomBlendInactive: "="
            }
          ]
        })
        .then(response => {
          self.customBlends = [];
          var parse = response.data.response.data;

          parse.forEach(function(element) {
            self.customBlends.push(element.fieldData);
          });
          
        })
        .catch(error=>{
          console.log(error)
        })
    },

    loadData: async function() {
      var self = this;
      axios.post(`proxy.php?/layouts/product-config-lookup/_find`, {
          query: [
            {
              isWholesalerProduct: "=" + 1,
              productType: self.tabFilter
            }
          ],
          sort: [
            {
              fieldName: "productName", sortOrder: "ascend"
            }
          ],
          limit: self.perPage,
          offset: self.offset
        })
        .then(response => {
          self.products = [];
          var parse = response.data.response.data;
          self.total = parse[0].fieldData.zcnFoundCount;

          parse.forEach(function(element) {
            element.fieldData.isOpen = false
            self.products.push(element.fieldData);
          });
          
        })
        .catch(error => {
          this.isLoading = false
          console.log(error);
        });
        await self.productLookup();
        this.isLoading = false

    },

    setTab: function(param){
      var self = this;
      self.page = 1
      //tab 0 is "All Products"
      if (param == 0) {
        self.tabFilter = "Coffee"
      }
      //tab 1 is "Coffee"
      else if (param == 1) {
        self.tabFilter = "Sweet Justice"
      }
      //tab 2 is "Green Beans"
      else if (param == 2) {
        self.tabFilter = "Limited Edition"
      }
      //tab 3 is "Sweet Justice"
      else if (param == 3) {
        self.tabFilter = "Supplies"
      }
      //tab 3 is "Limited Edition"
      else if (param == 4) {
        self.tabFilter = "Green Beans"
      }
      else if (param == 5) {
        self.tabFilter = ""
      }
      self.productLookup()
    },

    productLookup: function() {
      var self = this;
      
      return axios
        .post(`proxy.php?/layouts/product-config-lookup/_find`, {
          query: [
            {
              isWholesalerProduct: 1,
              productName: self.productFilter,
              productType: self.tabFilter,
            }
          ],
          sort: [
            {
              fieldName: "productName", sortOrder: "ascend"
            }
          ],
          limit: self.perPage,
          offset: self.offset
        })
        .then(response => {
          self.products = [];
          var parse = response.data.response.data;
          self.total = parse[0].fieldData.zcnFoundCount;

          parse.forEach(function(element) {
            self.products.push(element.fieldData);
          });
        })
        .catch(error => {
          self.products = [];
          console.log(error);
        });
    },

    loadLineData: function(sku){
      var self = this;
      var arrayPosition = self.products.findIndex(product=>product.base_sku == sku);
      self.products[arrayPosition].productLines = [];
      return axios
        .post(`proxy.php?/layouts/product-lookup/_find`, {
          query: [
            {
              wholesaleSyncVariant: "1",
              isCustomBlend: "=",
              priceWholesale: "*",
              base_sku: '="'+ sku + '"'
            }
          ],
          sort: [
            {
              fieldName: "weight", sortOrder: "descend"
            },
            {
              //custom sort value list.
              fieldName: "grind", sortOrder: "Grinds"
            }
          ]
        })
        .then(response => {
          var parse = response.data.response.data;

          parse.forEach(function(element) {
            self.products[arrayPosition].productLines.push(element.fieldData);
          });
          self.products.splice(self.products.length)
        })
        .catch(error => {
          console.log(error);
        });
    },

    onPageChange(page) {
      this.page = page;
      this.productLookup();
    },

    checkQuantity: function(product){
      var self = this;
      var product = product;
      this.$buefy.dialog.prompt({
      message: `How many would you like to add?`,
      inputAttrs: {
          type: 'number',
          placeholder: 'Type quantity',
          value: '1',
          maxlength: 3,
          min: 1
      },
      onConfirm: (value) => self.addToCart(product, value)
      })
    },

    addToCart: function(product, qty) {
      var self = this;
      var found = false;
      for (var i = 0; i < self.cart.products.length; i++){
        if ( self.cart.products[i].__kptID === product.__kptID){
          self.cart.products[i].quantity = parseInt(self.cart.products[i].quantity, 10) + parseInt(qty, 10);
          found = true
        }
      }
      if (!found){
        var cartProduct = {
          __kptID: product.__kptID,
          price: product.priceWholesale,
          productName: product.productName,
          quantity: qty,
          isCustomBlend: false
        }
        self.cart.products.push(cartProduct);
      }
      self.setCart(self.cart)
      self.$root.$children[0].$refs.toast.success("Product Added", "Added to Cart!")

    },

    checkQuantityBlend: function(product){
      var self = this;
      var product = product;
      this.$buefy.dialog.prompt({
      message: `How many would you like to add?`,
      inputAttrs: {
          type: 'number',
          placeholder: 'Type quantity',
          value: '1',
          maxlength: 3,
          min: 1
      },
      onConfirm: (value) => self.addBlendToCart(product, value)
      })
    },

    addBlendToCart: function(blend, qty) {
      var self = this;
      var found = false;
      for (var i = 0; i < self.cart.products.length; i++){
        if ( self.cart.products[i].__kptID === blend.__kptID){
          self.cart.products[i].quantity = qty;
          found = true
        }
      }
      if (!found){
        var cartCustomBlend = {
          __kptID: blend.__kptID,
          price: blend.priceWholesale,
          productName: blend.productName + ' - ' + blend.weight +  ' lb',
          quantity: qty,
          isCustomBlend: true
        }
        self.cart.products.push(cartCustomBlend);
      }
      self.setCart(self.cart)
      self.$root.$children[0].$refs.toast.success("Product Added", "Added to Cart!")


    },    
    
    checkQuantityRecent: function(product){
      var self = this;
      var product = product;
      this.$buefy.dialog.prompt({
      message: `How many would you like to add?`,
      inputAttrs: {
          type: 'number',
          placeholder: 'Type quantity',
          value: '1',
          maxlength: 3,
          min: 1
      },
      onConfirm: (value) => self.addRecentToCart(product, value)
      })
    },

    addRecentToCart: function(recent, qty) {
      var self = this;
      var found = false;
      for (var i = 0; i < self.cart.products.length; i++){
        if ( self.cart.products[i].__kptID === recent.__kptID){
          self.cart.products[i].quantity = qty;
          found = true
        }
      }
      if (!found){
        var cartCustomBlend = {
          __kptID: recent._kftProductID,
          price: recent.price,
          productName: recent.productName,
          quantity: qty,
          isCustomBlend: recent.isCustomBlend
        }
        self.cart.products.push(cartCustomBlend);
      }
      self.setCart(self.cart)
      self.$root.$children[0].$refs.toast.success("Product Added", "Added to Cart!")

    },

    openOrClose(){
      this.isCustomBlendOpen = !this.isCustomBlendOpen
    },

    openOrCloseRP(){
      this.isRecentlyPurchasedOpen = !this.isRecentlyPurchasedOpen
    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.has-text-danger {
  padding-bottom: 20px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.card-container {
  padding: 2rem;
  margin: 0px 20px 20px 20px;
}

.productWindow{
  min-height: 500px
}

.noProducts{
  text-align: center;
  padding-top: 20px;
}

.detail-container{
  padding: 0px !important;
}
/*.field-container {*/
/*  background-color: #FFFFFF;*/
/*  border: solid 1px #cccccc;*/
/*  border-radius: 5px;*/
/*  padding: 2rem;*/
/*  margin: 0px 20px 20px 20px;*/
/*}  */
</style>
